module.exports = __webpack_public_path__ + "media/images/note-pasien-9bb6e5b2.svg";